export default {"src":"https://cdn2.e-farm.com/website-static/_next/static/media/de.1fe47647.svg","height":3,"width":5,"blurWidth":0,"blurHeight":0};